import * as Factory from 'factory.ts'
import faker from 'faker'

import { type PurchaseListItem } from '@webapp/models'
import { OrderItemTypes } from '@webapp/models/enums'
import { CurrencyMock } from './currency.factory'
import { VendorMock } from './vendor.factory'

export const PurchaseListItemMock = Factory.Sync.makeFactory<PurchaseListItem>({
  currency: CurrencyMock.build({ name: 'CAD' }),
  date_required: Factory.each(() => faker.date.future().toISOString()),
  lineComment: Factory.each(() => faker.lorem.sentence()),
  num: Factory.each(() => faker.random.number().toString()),
  orderNum: Factory.each(() => faker.random.number()),
  order_uuid: Factory.each(() => faker.random.uuid()),
  pref_vendor: Factory.each(() => {
    const { id, name, overall_score, email, contact, active } =
      VendorMock.build()

    return { id, name, overall_score, email, contact, active }
  }),
  price: Factory.each(() => faker.commerce.price()),
  approved_price: Factory.each(() => faker.commerce.price()),
  quantity: Factory.each(() => faker.random.number().toString()),
  unit: Factory.each(() => faker.commerce.productAdjective()),
  catalog_item: null,
  custom_fields: [],
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.commerce.productName()),
  recurrence: null,
  total_cost: Factory.each(() => faker.commerce.price()),
  account_id: Factory.each(() => faker.random.number()),
  sku: Factory.each(() => faker.random.alphaNumeric(6)),
  type: OrderItemTypes.ONE_TIME,
}).withDerivation1(['pref_vendor'], 'vendor', (prefVendor) => {
  if (prefVendor.id === 1) {
    return VendorMock.build().name
  } else {
    return prefVendor.name
  }
})
